import type { CaseStudiesFilterFragment } from '@/utils/dato/generated';
import type { CaseStudiesListContext } from '@/utils/models/caseStudiesList/caseStudiesList';

const CaseStudiesFilter = ({ pageContext }: { pageContext: CaseStudiesListContext } & CaseStudiesFilterFragment) => {
  const { pagination } = pageContext;

  return (
    <div className="container-business px-4 flex items-center justify-between pt-8 pb-7">
      {pagination.totalPages <= 1 ? null : (
        <span className="text-base-400 font-medium">
          Page {pagination.currentPage} of {pagination.totalPages}
        </span>
      )}
    </div>
  );
};

export default CaseStudiesFilter;
